import React from 'react';
import {
  AcUnit,
  Adjust,
  Air,
  AutoStories,
  Bathtub,
  BreakfastDining,
  Castle,
  Coffee,
  DesktopWindows,
  ElectricCar,
  Fireplace,
  FitnessCenter,
  Garage,
  Grass,
  HotTub,
  Iron,
  Kitchen,
  LocalFireDepartment,
  LocalLaundryService,
  LocalParking,
  MedicalServices,
  Microwave,
  OutdoorGrill,
  PedalBike,
  PhotoAlbum,
  Pool,
  SelfImprovement,
  Shower,
  SmokeFree,
  SpeakerGroup,
  SportsBaseball,
  SportsEsports,
  Surfing,
  Kayaking,
  Sailing,
  Kitesurfing,
  TableRestaurant,
  Thermostat,
  Tv,
  Videocam,
  Whatshot,
  Wifi,
} from '@mui/icons-material';
import { AmenityId } from '../types/amenity';

export const AMENITY_ICONS: Record<AmenityId, React.ReactElement> = {
  // Kitchen
  oven: <Kitchen />,
  microwave: <Microwave />,
  dishwasher: <LocalLaundryService />,
  fridge: <Kitchen />,
  freezer: <AcUnit />,
  coffeeMaker: <Coffee />,
  kettle: <Coffee />,
  toaster: <BreakfastDining />,
  // Laundry
  washingMachine: <LocalLaundryService />,
  dryer: <LocalLaundryService />,
  iron: <Iron />,
  // Bathroom
  bathtub: <Bathtub />,
  shower: <Shower />,
  hairDryer: <FitnessCenter />,
  // Climate
  heating: <Thermostat />,
  airConditioning: <AcUnit />,
  fireplace: <Fireplace />,
  woodStove: <Whatshot />,
  fan: <Air />,
  // Entertainment
  tv: <Tv />,
  projector: <Videocam />,
  speakers: <SpeakerGroup />,
  wifi: <Wifi />,
  boardGames: <Castle />,
  books: <AutoStories />,
  comics: <PhotoAlbum />,
  billiards: <Adjust />,
  gameConsole: <SportsEsports />,
  paddle: <Surfing />,
  canoe: <Kayaking />,
  windsurf: <Sailing />,
  wingfoil: <Kitesurfing />,
  // Outdoor
  garden: <Grass />,
  terrace: <Grass />,
  bbq: <OutdoorGrill />,
  pool: <Pool />,
  hotTub: <HotTub />,
  bikesAvailable: <PedalBike />,
  hammock: <SelfImprovement />,
  pingPongTable: <SportsBaseball />,
  gardenFurniture: <TableRestaurant />,
  // Safety
  smokeDetector: <SmokeFree />,
  firstAidKit: <MedicalServices />,
  fireExtinguisher: <LocalFireDepartment />,
  // Connectivity
  workDesk: <DesktopWindows />,
  // Parking
  parking: <LocalParking />,
  garage: <Garage />,
  evCharger: <ElectricCar />,
};
